import {
	createReducer,
	createSlice,
	createAction,
	createAsyncThunk,
	createEntityAdapter,
} from '@reduxjs/toolkit';


import { API } from '../../api';

// FIXME: MOVE TO API
export const fetchHistory = createAsyncThunk(
	"requests/fetchHistory",
	async (data, thunkAPI)  => {
		let response = await API.getHistory(data);

		if(response.cursor) 
			thunkAPI.dispatch(fetchHistory({ ...data, cursor: response.cursor }) );

		return response;
	}
);

const historySlice = createSlice({
	name: "history",
	initialState: {
		byRequest: {},
		loading: 'idle'
	},
	reducers: {
	},
	extraReducers: {
		[fetchHistory.pending]:  (state, action) => {
			state.loading = 'loading';
		},
		[fetchHistory.fulfilled]:  (state, action) => {
			let key = action.meta.arg.key;
			let cursor = action.payload.cursor;
			if(state.byRequest[key] === undefined)
				state.byRequest[key] = [];
			
//			console.warn("fetchHistory.fulfilled: %o, cursor: %o", action, cursor);			
			state.byRequest[key] = [...state.byRequest[key], ...action.payload.notes];
			if(!cursor)
				state.loading = 'idle';
		},
		[fetchHistory.rejected]:  (state, action) => {
			console.warn("fetchHistory.rejected: %o", action);
		},		
	}
});


// export const { setCurrentRequest } = requestsSlice.actions;
export default historySlice.reducer; 
